/* ============================================================
   Lustre — Jewelry Theme — theme.js
   ============================================================ */
(function () {
  'use strict';

  var routes = (window.theme && window.theme.routes) || {};
  var strings = (window.theme && window.theme.strings) || {};

  /* ---------- helpers ---------- */
  function formatMoney(cents) {
    var value = (cents / 100).toFixed(2);
    var fmt = (window.theme && window.theme.moneyFormat) || '${{amount}}';
    return fmt.replace(/\{\{\s*amount\s*\}\}/, value.replace(/\d(?=(\d{3})+\.)/g, '$&,'));
  }

  function toast(message) {
    var el = document.querySelector('.toast');
    if (!el) {
      el = document.createElement('div');
      el.className = 'toast';
      document.body.appendChild(el);
    }
    el.textContent = message;
    requestAnimationFrame(function () { el.classList.add('is-visible'); });
    clearTimeout(el._t);
    el._t = setTimeout(function () { el.classList.remove('is-visible'); }, 2600);
  }

  /* ---------- overlay + body scroll ---------- */
  function getOverlay() {
    var overlay = document.querySelector('.overlay');
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.className = 'overlay';
      document.body.appendChild(overlay);
      overlay.addEventListener('click', closeAll);
    }
    return overlay;
  }

  function openDrawer(selector) {
    var drawer = document.querySelector(selector);
    if (!drawer) return;
    drawer.classList.add('is-open');
    getOverlay().classList.add('is-open');
    document.body.classList.add('no-scroll');
    drawer.setAttribute('aria-hidden', 'false');
  }

  function closeAll() {
    document.querySelectorAll('.drawer.is-open').forEach(function (d) {
      d.classList.remove('is-open');
      d.setAttribute('aria-hidden', 'true');
    });
    var overlay = document.querySelector('.overlay');
    if (overlay) overlay.classList.remove('is-open');
    document.body.classList.remove('no-scroll');
  }

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) { e.preventDefault(); openDrawer(opener.getAttribute('data-drawer-open')); }
    if (e.target.closest('[data-drawer-close]')) { e.preventDefault(); closeAll(); }
  });

  /* ---------- Cart ---------- */
  var Cart = {
    updateCount: function (count) {
      document.querySelectorAll('.cart-count').forEach(function (el) {
        el.textContent = count;
        el.style.display = count > 0 ? 'flex' : 'none';
      });
    },

    async fetchAndRender() {
      try {
        var res = await fetch(routes.cart_url + '.js', { headers: { 'Content-Type': 'application/json' } });
        var cart = await res.json();
        var changed = await this.maybeGift(cart);
        if (changed) {
          res = await fetch(routes.cart_url + '.js', { headers: { 'Content-Type': 'application/json' } });
          cart = await res.json();
        }
        this.render(cart);
        this.updateCount(cart.item_count);
      } catch (err) { /* silent */ }
    },

    // Auto-add / remove a free gift based on the qualifying cart total.
    async maybeGift(cart) {
      // Never mutate the cart while editing in the theme editor.
      if (window.Shopify && window.Shopify.designMode) return false;
      var gift = (window.theme && window.theme.gift) || {};
      if (!gift.enabled || !gift.variantId) return false;

      var giftLine = null;
      var qualifying = 0;
      cart.items.forEach(function (it) {
        if (it.variant_id === gift.variantId) { giftLine = it; }
        else { qualifying += it.final_line_price; }
      });
      var eligible = qualifying >= gift.threshold;

      try {
        if (eligible && !giftLine) {
          await fetch(routes.cart_add_url + '.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id: gift.variantId, quantity: 1 }] })
          });
          return true;
        }
        if (!eligible && giftLine) {
          await fetch(routes.cart_change_url + '.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: gift.variantId, quantity: 0 })
          });
          return true;
        }
        // keep the gift quantity locked to 1
        if (giftLine && giftLine.quantity > 1) {
          await fetch(routes.cart_change_url + '.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: gift.variantId, quantity: 1 })
          });
          return true;
        }
      } catch (e) { /* silent */ }
      return false;
    },

    async add(id, quantity) {
      var body = { items: [{ id: id, quantity: quantity || 1 }] };
      var res = await fetch(routes.cart_add_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      });
      if (!res.ok) { toast(strings.cartError || 'Could not add to cart'); return null; }
      var item = await res.json();
      await this.fetchAndRender();
      openDrawer('#CartDrawer');
      return item;
    },

    async change(line, quantity) {
      var res = await fetch(routes.cart_change_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      });
      var cart = await res.json();
      var changed = await this.maybeGift(cart);
      if (changed) {
        res = await fetch(routes.cart_url + '.js', { headers: { 'Content-Type': 'application/json' } });
        cart = await res.json();
      }
      this.render(cart);
      this.updateCount(cart.item_count);
    },

    render: function (cart) {
      this.renderRewards(cart.total_price || 0);

      var countEl = document.querySelector('#CartDrawerCount');
      if (countEl) {
        countEl.textContent = cart.item_count;
        countEl.hidden = cart.item_count === 0;
      }

      var container = document.querySelector('#CartDrawerBody');
      if (!container) return;

      var footer = document.querySelector('#CartDrawerFooter');
      var upsells = document.querySelector('#CartUpsells');

      if (cart.item_count === 0) {
        container.innerHTML =
          '<div class="cart-empty">' +
            '<div class="cart-empty__icon">' +
              '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3"><path d="M3 3h2l2.4 12.3a1 1 0 0 0 1 .7h9.7a1 1 0 0 0 1-.8L21 8H6"/><circle cx="9" cy="20" r="1.4"/><circle cx="18" cy="20" r="1.4"/></svg>' +
            '</div>' +
            '<p class="cart-empty__text">Your cart is empty.</p>' +
            '<a href="/collections/all" class="btn btn--primary" data-drawer-close>Start shopping</a>' +
          '</div>';
        if (footer) footer.hidden = true;
        if (upsells) upsells.style.display = 'none';
        return;
      }

      if (footer) footer.hidden = false;
      if (upsells) upsells.style.display = '';

      var gift = (window.theme && window.theme.gift) || {};
      var html = '';

      cart.items.forEach(function (item, i) {
        var img = item.image ? item.image.replace(/(\.[^.]+)$/, '_200x$1') : '';
        var isGift = gift.enabled && item.variant_id === gift.variantId;
        var variant = (item.variant_title && item.variant_title !== 'Default Title') ? item.variant_title : '';
        var onSale = item.original_line_price > item.final_line_price;

        html += '<div class="cart-item' + (isGift ? ' cart-item--gift' : '') + '" data-line="' + (i + 1) + '">' +
          '<a href="' + item.url + '" class="cart-item__media"><img src="' + img + '" alt="" width="72" height="72" loading="lazy"></a>' +
          '<div class="cart-item__info">' +
            '<a href="' + item.url + '" class="cart-item__title">' + item.product_title + '</a>' +
            (isGift
              ? '<div class="cart-item__variant"><span class="gift-tag">Gift</span> Added free at your reward tier</div>'
              : (variant ? '<div class="cart-item__variant">' + variant + '</div>' : '')) +
            (isGift ? '' :
              '<div class="cart-item__actions">' +
                '<div class="qty qty--sm">' +
                  '<button type="button" data-qty-down aria-label="Decrease">&minus;</button>' +
                  '<input type="number" min="0" inputmode="numeric" value="' + item.quantity + '" data-qty-input aria-label="Quantity">' +
                  '<button type="button" data-qty-up aria-label="Increase">+</button>' +
                '</div>' +
                '<button type="button" class="cart-item__remove" data-remove aria-label="Remove">Remove</button>' +
              '</div>') +
          '</div>' +
          '<div class="cart-item__pricing">' +
            (isGift
              ? '<span class="cart-item__price cart-item__price--free">Free</span>'
              : '<span class="cart-item__price">' + formatMoney(item.final_line_price) + '</span>' +
                (onSale ? '<span class="cart-item__was">' + formatMoney(item.original_line_price) + '</span>' : '')) +
          '</div>' +
        '</div>';
      });

      container.innerHTML = html;

      var subtotalEl = document.querySelector('#CartSubtotal');
      if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
    },

    renderRewards: function (total) {
      document.querySelectorAll('[data-rewards]').forEach(function (bar) {
        var tiers;
        try { tiers = JSON.parse(bar.getAttribute('data-tiers')); } catch (e) { return; }
        if (!tiers || !tiers.length) return;
        tiers.sort(function (a, b) { return a.amount - b.amount; });
        var max = tiers[tiers.length - 1].amount;

        var fill = bar.querySelector('.rewards-bar__fill');
        if (fill) fill.style.width = (max > 0 ? Math.min(100, (total / max) * 100) : 0) + '%';

        bar.querySelectorAll('.rewards-bar__milestone, .rewards-tier').forEach(function (m) {
          var amt = parseInt(m.getAttribute('data-amount'), 10);
          m.classList.toggle('is-reached', total >= amt);
        });

        var msg = bar.querySelector('.rewards-bar__message');
        if (!msg) return;
        var next = null;
        for (var i = 0; i < tiers.length; i++) {
          if (total < tiers[i].amount) { next = tiers[i]; break; }
        }
        if (next) {
          msg.innerHTML = 'Spend <b>' + formatMoney(next.amount - total) + '</b> more to unlock <b>' + next.label + '</b>';
        } else {
          msg.innerHTML = "You've unlocked every reward!";
        }
      });
    }
  };
  window.Cart = Cart;

  /* cart drawer interactions — only act on the drawer's qty/remove buttons */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-up], [data-qty-down], [data-remove]');
    if (!btn) return;
    if (btn.closest('[data-cart-page]')) return; // cart page handles its own
    var item = btn.closest('.cart-item');
    if (!item) return;
    var line = parseInt(item.getAttribute('data-line'), 10);
    var input = item.querySelector('[data-qty-input]');
    var qty = input ? parseInt(input.value, 10) : 1;
    if (btn.hasAttribute('data-qty-up')) Cart.change(line, qty + 1);
    else if (btn.hasAttribute('data-qty-down')) Cart.change(line, Math.max(0, qty - 1));
    else if (btn.hasAttribute('data-remove')) Cart.change(line, 0);
  });

  /* typing a quantity directly in the drawer input */
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-qty-input]');
    if (!input) return;
    if (input.closest('[data-cart-page]')) return; // cart page handles its own
    var item = input.closest('.cart-item');
    if (!item) return;
    var line = parseInt(item.getAttribute('data-line'), 10);
    var q = parseInt(input.value, 10);
    if (isNaN(q) || q < 0) q = 0;
    Cart.change(line, q);
  });

  /* quick add buttons on cards */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    e.preventDefault();
    var id = btn.getAttribute('data-quick-add');
    btn.classList.add('is-disabled');
    btn.textContent = 'Adding…';
    Cart.add(id, 1).then(function () {
      btn.classList.remove('is-disabled');
      btn.textContent = btn.getAttribute('data-label') || 'Add to cart';
    });
  });

  /* ---------- Product form ---------- */
  function initProductForm(form) {
    var data = JSON.parse(form.querySelector('[data-variants]').textContent);
    var selected = {};
    var addBtn = form.querySelector('[data-add-btn]');
    var priceEl = form.querySelector('[data-price]');
    var idInput = form.querySelector('[data-variant-id]');

    function findVariant() {
      var options = form.querySelectorAll('[data-option-index]');
      var chosen = [];
      options.forEach(function (group) {
        var idx = group.getAttribute('data-option-index');
        chosen[idx] = selected[idx];
      });
      return data.find(function (v) {
        return v.options.every(function (opt, i) { return opt === chosen[i]; });
      });
    }

    function update() {
      var variant = findVariant();
      if (!variant) {
        addBtn.textContent = strings.unavailable || 'Unavailable';
        addBtn.disabled = true;
        return;
      }
      idInput.value = variant.id;
      if (priceEl) {
        var html = '<span class="price ' + (variant.compare_at_price > variant.price ? 'price--accent' : '') + '">' + formatMoney(variant.price) + '</span>';
        if (variant.compare_at_price > variant.price) {
          html += ' <span class="price__compare">' + formatMoney(variant.compare_at_price) + '</span>';
        }
        priceEl.innerHTML = html;
      }
      if (variant.available) {
        addBtn.textContent = strings.addToCart || 'Add to cart';
        addBtn.disabled = false;
      } else {
        addBtn.textContent = strings.soldOut || 'Sold out';
        addBtn.disabled = true;
      }
    }

    form.querySelectorAll('.variant-pill').forEach(function (pill) {
      var idx = pill.closest('[data-option-index]').getAttribute('data-option-index');
      if (pill.classList.contains('is-selected')) selected[idx] = pill.getAttribute('data-value');
      pill.addEventListener('click', function () {
        pill.parentNode.querySelectorAll('.variant-pill').forEach(function (p) { p.classList.remove('is-selected'); });
        pill.classList.add('is-selected');
        selected[idx] = pill.getAttribute('data-value');
        update();
      });
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var variant = findVariant();
      if (!variant || !variant.available) return;
      var qtyInput = form.querySelector('[data-product-qty]');
      var qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
      addBtn.disabled = true;
      var original = addBtn.textContent;
      addBtn.textContent = 'Adding…';
      Cart.add(variant.id, qty).then(function () {
        addBtn.disabled = false;
        addBtn.textContent = original;
      });
    });

    update();
  }

  /* ---------- Product gallery ---------- */
  function initGallery(gallery) {
    var main = gallery.querySelector('[data-main-image] img');
    gallery.querySelectorAll('.product__thumb').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        gallery.querySelectorAll('.product__thumb').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        if (main) main.src = thumb.getAttribute('data-full');
      });
    });
  }

  /* ---------- Accordions ---------- */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('.accordion__trigger');
    if (!trigger) return;
    var item = trigger.closest('.accordion__item');
    var content = item.querySelector('.accordion__content');
    var open = item.classList.toggle('is-open');
    content.style.maxHeight = open ? content.scrollHeight + 'px' : '0';
  });

  /* ---------- Sticky ATC ---------- */
  function initStickyAtc() {
    var sticky = document.querySelector('.sticky-atc');
    var trigger = document.querySelector('[data-add-btn]');
    if (!sticky || !trigger) return;
    var observer = new IntersectionObserver(function (entries) {
      sticky.classList.toggle('is-visible', !entries[0].isIntersecting);
    }, { rootMargin: '0px 0px -80px 0px' });
    observer.observe(trigger);
    var stickyBtn = sticky.querySelector('[data-sticky-add]');
    if (stickyBtn) stickyBtn.addEventListener('click', function () { trigger.click(); });
  }

  /* ---------- Reveal on scroll ---------- */
  function initReveal() {
    var els = document.querySelectorAll('.reveal');
    if (!els.length || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-visible'); obs.unobserve(entry.target); }
      });
    }, { threshold: 0.12 });
    els.forEach(function (el) { obs.observe(el); });
  }

  /* ---------- Predictive search ---------- */
  function initSearch() {
    var input = document.querySelector('[data-predictive-search]');
    if (!input || !routes.predictive_search_url) return;
    var results = document.querySelector('[data-search-results]');
    var rec = document.querySelector('[data-search-rec]');
    var timer;
    function showRecs(show) { if (rec) rec.style.display = show ? '' : 'none'; }
    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < 2) {
        if (results) results.innerHTML = '';
        showRecs(true);
        return;
      }
      showRecs(false);
      timer = setTimeout(function () {
        fetch(routes.predictive_search_url + '?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&section_id=predictive-search')
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var inner = doc.querySelector('[data-search-results]');
            if (results && inner) results.innerHTML = inner.innerHTML;
          });
      }, 250);
    });
  }

  /* ---------- Cart page: live quantity updates ---------- */
  function initCartPage() {
    var page = document.querySelector('[data-cart-page]');
    if (!page) return;
    var sectionId = page.getAttribute('data-section-id');
    var busy = false;

    async function apply(line, quantity) {
      if (busy) return;
      busy = true;
      page.classList.add('is-updating');
      try {
        await fetch(routes.cart_change_url + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ line: line, quantity: quantity })
        });

        // Re-render just this section so line prices + subtotal are correct
        var res = await fetch(window.location.pathname + '?section_id=' + sectionId);
        if (res.ok) {
          var html = await res.text();
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-cart-page]') || doc.body.firstElementChild;
          if (fresh) page.innerHTML = fresh.innerHTML;
        }

        // Resync the rewards/shipping bar, header count and drawer
        await Cart.fetchAndRender();
      } catch (e) { /* silent */ }
      page.classList.remove('is-updating');
      busy = false;
    }

    page.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-qty-up], [data-qty-down], [data-remove]');
      if (!btn) return;
      e.preventDefault();
      var item = btn.closest('.cart-item');
      if (!item) return;
      var line = parseInt(item.getAttribute('data-line'), 10);
      var input = item.querySelector('[data-qty-input]');
      var q = input ? parseInt(input.value, 10) : 1;
      if (isNaN(q)) q = 1;
      if (btn.hasAttribute('data-qty-up')) apply(line, q + 1);
      else if (btn.hasAttribute('data-qty-down')) apply(line, Math.max(0, q - 1));
      else apply(line, 0);
    });

    page.addEventListener('change', function (e) {
      var input = e.target.closest('[data-qty-input]');
      if (!input) return;
      var item = input.closest('.cart-item');
      if (!item) return;
      var line = parseInt(item.getAttribute('data-line'), 10);
      var q = parseInt(input.value, 10);
      if (isNaN(q) || q < 0) q = 0;
      apply(line, q);
    });
  }

  /* ---------- Custom builder wizard ---------- */
  function initCustomBuilder() {
    var root = document.querySelector('[data-custom-builder]');
    if (!root) return;

    var allSteps = Array.prototype.slice.call(root.querySelectorAll('.cb-step'));
    if (!allSteps.length) return;
    var backBtn = root.querySelector('#cbBack');
    var nextBtn = root.querySelector('#cbNext');
    var submitBtn = root.querySelector('#cbSubmit');
    var progressFill = root.querySelector('#cbProgressFill');
    var stepNow = root.querySelector('#cbStepNow');
    var stepTotal = root.querySelector('#cbStepTotal');
    var priceEl = root.querySelector('#cbPrice');
    var priceField = root.querySelector('#cbPriceField');
    var preview = root.querySelector('#cbPreview');
    var summary = root.querySelector('#cbSummary');
    var basePrice = parseInt(root.getAttribute('data-base-price'), 10) || 0;
    var currentEl = allSteps[0];
    var autoAdvance = root.getAttribute('data-auto-advance') !== 'false';
    var advancing = false;

    function money(c) { return formatMoney(c); }

    // Every option label chosen so far, lowercased, for data-show-if matching.
    function chosenLabels() {
      var out = [];
      allSteps.forEach(function (st) {
        var sel = st.querySelector('.cb-opt.is-selected');
        if (sel) out.push((sel.getAttribute('data-label') || '').toLowerCase());
      });
      return out;
    }

    // A step carrying data-show-if only enters the flow once a matching answer is picked.
    function stepVisible(st) {
      var cond = st.getAttribute('data-show-if');
      if (!cond) return true;
      var have = chosenLabels();
      return cond.split(',').some(function (want) {
        want = want.trim().toLowerCase();
        return want && have.indexOf(want) !== -1;
      });
    }

    function visibleSteps() { return allSteps.filter(stepVisible); }

    function total() {
      var t = basePrice;
      visibleSteps().forEach(function (st) {
        var sel = st.querySelector('.cb-opt.is-selected');
        if (sel) t += parseInt(sel.getAttribute('data-price'), 10) || 0;
      });
      return t;
    }

    function refreshPrice() {
      var t = total();
      if (priceEl) priceEl.textContent = money(t);
      if (priceField) priceField.value = money(t);
    }

    function answerFor(st) {
      if (!st) return '';
      var sel = st.querySelector('.cb-opt.is-selected');
      if (sel) {
        var label = sel.getAttribute('data-label') || '';
        // An "Other" option only counts once they've typed something.
        if (sel.hasAttribute('data-opens-input')) {
          var other = st.querySelector('[data-other-input]');
          var typed = other ? other.value.trim() : '';
          return typed ? label + ' — ' + typed : '';
        }
        return label;
      }
      var field = st.querySelector('[data-field]');
      if (field) return field.value.trim();
      return '';
    }

    function syncAnswer(st) {
      if (!st) return;
      var hidden = st.querySelector('[data-answer]');
      if (hidden) hidden.value = answerFor(st);
    }

    function buildSummary() {
      if (!summary) return;
      summary.innerHTML = '';
      visibleSteps().forEach(function (st) {
        if (st.classList.contains('cb-step--review')) return;
        var ans = answerFor(st);
        if (!ans) return;
        var li = document.createElement('li');
        li.innerHTML = '<span class="cb-summary__q">' + st.getAttribute('data-name') + '</span><span class="cb-summary__a">' + ans + '</span>';
        summary.appendChild(li);
      });
    }

    function render(doScroll) {
      var list = visibleSteps();
      // If a changed answer hid the step we were on, fall back to the first one.
      if (list.indexOf(currentEl) === -1) currentEl = list[0];
      var idx = list.indexOf(currentEl);
      allSteps.forEach(function (st) { st.hidden = st !== currentEl; });

      var last = idx === list.length - 1;
      if (backBtn) backBtn.hidden = idx <= 0;
      if (nextBtn) nextBtn.hidden = last || !needsContinue(currentEl);
      if (submitBtn) submitBtn.hidden = !last;
      if (progressFill) progressFill.style.width = ((idx + 1) / list.length * 100) + '%';
      if (stepNow) stepNow.textContent = idx + 1;
      if (stepTotal) stepTotal.textContent = list.length;
      if (last) buildSummary();

      if (doScroll) {
        var panel = root.querySelector('.cb__panel');
        if (panel) panel.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    }

    function move(delta) {
      var list = visibleSteps();
      var idx = list.indexOf(currentEl);
      currentEl = list[Math.max(0, Math.min(idx + delta, list.length - 1))];
      render(true);
    }

    function valid(st) {
      if (!st.hasAttribute('data-required')) return true;
      return !!answerFor(st);
    }

    // Steps made of tappable options (cards / swatches / buttons).
    function isChoiceStep(st) { return !!(st && st.querySelector('.cb-opt')); }

    // Picking an option is the decision, so those steps move on by themselves
    // and don't need a Continue button.
    function selfAdvancing(st) {
      if (!autoAdvance || !isChoiceStep(st)) return false;
      if (st.classList.contains('cb-step--review')) return false;
      var sel = st.querySelector('.cb-opt.is-selected');
      if (sel && sel.hasAttribute('data-opens-input')) return false; // "Other" needs typing first
      return true;
    }

    // Continue stays hidden only while a choice step is still unanswered —
    // it comes back if they navigate back to one, or pick "Other".
    function needsContinue(st) {
      if (advancing) return false;
      if (!st || !selfAdvancing(st)) return true;
      return !!st.querySelector('.cb-opt.is-selected');
    }

    // option selection
    root.addEventListener('click', function (e) {
      var opt = e.target.closest('.cb-opt');
      if (!opt) return;
      var step = opt.closest('.cb-step');
      step.querySelectorAll('.cb-opt').forEach(function (o) { o.classList.remove('is-selected'); });
      opt.classList.add('is-selected');

      // "Other" reveals a free-text box; anything else puts it away.
      var other = step.querySelector('[data-other-input]');
      if (other) {
        if (opt.hasAttribute('data-opens-input')) {
          other.placeholder = opt.getAttribute('data-input-placeholder') || 'Type your answer';
          other.hidden = false;
          other.focus();
        } else {
          other.hidden = true;
          other.value = '';
        }
      }

      syncAnswer(step);
      if (step.hasAttribute('data-preview') && preview) {
        var img = opt.getAttribute('data-image');
        if (img) { preview.src = img; preview.hidden = false;
          var ph = root.querySelector('.cb__preview-placeholder'); if (ph) ph.style.display = 'none'; }
      }
      refreshPrice();

      // The pick is the decision — move to the next step for them.
      var list = visibleSteps();
      var atEnd = list.indexOf(step) === list.length - 1;
      if (selfAdvancing(step) && step === currentEl && !atEnd && valid(step)) {
        advancing = true;
        render(false);
        setTimeout(function () { advancing = false; move(1); }, 220);
      } else {
        render(false);
      }
    });

    // text / number / link / "other" inputs mirror to the hidden answer
    root.addEventListener('input', function (e) {
      var field = e.target.closest('[data-field], [data-other-input]');
      if (!field) return;
      syncAnswer(field.closest('.cb-step'));
    });

    if (nextBtn) nextBtn.addEventListener('click', function () {
      var st = currentEl;
      if (!valid(st)) { st.classList.add('cb-step--error'); setTimeout(function(){ st.classList.remove('cb-step--error'); }, 1200); return; }
      move(1);
    });
    if (backBtn) backBtn.addEventListener('click', function () { move(-1); });

    var form = root.querySelector('#cbForm');

    // Cart mode submit: add base product with line-item properties
    if (form && form.hasAttribute('data-cart-mode')) {
      form.addEventListener('submit', async function (e) {
        e.preventDefault();
        var vid = root.getAttribute('data-variant-id');
        if (!vid) { toast('No base product set'); return; }
        var props = {};
        visibleSteps().forEach(function (st) {
          if (st.classList.contains('cb-step--review')) return;
          var ans = answerFor(st);
          if (ans) props[st.getAttribute('data-name')] = ans;
        });
        props['Estimated total'] = money(total());
        await Cart.add(vid, 1);
        try {
          await fetch(routes.cart_change_url + '.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: vid, quantity: 1, properties: props })
          });
        } catch (err) {}
        window.location.href = routes.cart_url;
      });
    }

    // Quote mode: drop answers for steps that never applied, so they don't email through.
    if (form && !form.hasAttribute('data-cart-mode')) {
      form.addEventListener('submit', function () {
        allSteps.forEach(function (st) {
          var hidden = st.querySelector('[data-answer]');
          if (!hidden) return;
          if (stepVisible(st)) { hidden.value = answerFor(st); }
          else { hidden.disabled = true; }
        });
      });
    }

    refreshPrice();
    render(false);
  }

  /* ---------- Init ---------- */
  document.addEventListener('DOMContentLoaded', function () {
    Cart.fetchAndRender();
    document.querySelectorAll('[data-product-form]').forEach(initProductForm);
    document.querySelectorAll('[data-gallery]').forEach(initGallery);
    initStickyAtc();
    initReveal();
    initSearch();
    initCartPage();
    initCustomBuilder();
  });
})();
